import { render } from "./ModalAdministrar.vue?vue&type=template&id=63ef24de&scoped=true"
import script from "./ModalAdministrar.vue?vue&type=script&lang=js"
export * from "./ModalAdministrar.vue?vue&type=script&lang=js"

import "./ModalAdministrar.vue?vue&type=style&index=0&id=63ef24de&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63ef24de"]])

export default __exports__